import { gql } from "@apollo/client";

const SKIP_CHAPTER = gql`
  mutation SkipChapter($id: ID!) {
    skipChapter(input: { id: $id }) {
      chapter {
        id
      }
    }
  }
`;

export default SKIP_CHAPTER;
